import { PaletteMode } from '@mui/material';
import { createTheme, Theme } from '@mui/material/styles';
import { getPalette } from './palette';
import { typography } from './typography';
import { components } from './components';
import { ThemeConfig } from 'types/storefront';

export const createStoreTheme = (mode: PaletteMode, themeConfig?: ThemeConfig | null): Theme =>
  createTheme({
    palette: {
      ...getPalette(mode),
      ...(themeConfig?.primaryColor ? { primary: { main: themeConfig.primaryColor } } : {}),
      ...(themeConfig?.secondaryColor ? { secondary: { main: themeConfig.secondaryColor } } : {}),
    },
    typography: {
      ...typography,
      ...(themeConfig?.fontFamily ? { fontFamily: themeConfig.fontFamily } : {}),
    },
    components,
  });

export default createStoreTheme('light');
